import { Enumify } from "enumify-ts";
class MarketplaceFeeType extends Enumify() {
    description;
    static PER_UOM = new MarketplaceFeeType("Per UOM");
    static ONCE_OFF = new MarketplaceFeeType("Once Off");
    static _ = MarketplaceFeeType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return MarketplaceFeeType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
}
export default MarketplaceFeeType;
